import React from 'react';
import { ProjectLibraryTab } from '../components/projects/ProjectLibraryTab';

/**
 * Standalone library page (vertical-tab inside Site Management).
 * Reuses ProjectLibraryTab without a project context (the tab is generic).
 */
const LibraryPage = () => (
  <div data-testid="library-page">
    <ProjectLibraryTab project={{ name: '' }} />
  </div>
);

export default LibraryPage;
